<template>
  <clinician-app-layout>
    <template #header>
      <div class="pb-6 sm:flex sm:items-center sm:justify-between">
        <h2 class="text-3xl text-vice-teal-900 font-semibold leading-tight tracking-tight">
          Profile page
        </h2>
      </div>
      <div class="border-t border-gray-150 flex"></div>

      <div>
        <div class="sm:hidden py-2">
          <label for="tabs" class="sr-only">Select a tab</label>
          <select
            id="tabs"
            name="tabs"
            @change="setTabState($event.target.value)"
            class="
              block
              w-full
              focus:ring-indigo-500
              focus:border-indigo-500
              border-gray-300
              rounded-md
            "
          >
            <option v-for="tab in tabs" :key="tab.name" :selected="tab.current" :value="tab.id">
              {{ tab.name }}
            </option>
          </select>
        </div>
        <div class="hidden sm:block">
          <div>
            <nav class="mb-1 flex" aria-label="Tabs">
              <button
                v-for="tab in tabs"
                :key="tab.name"
                @click="setTabState(tab.id)"
                :class="[
                  'block',
                  tab.current
                    ? 'border-vice-teal-400 text-grey-900'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'w-1/5 py-4 px-1 text-center border-b-2 font-medium text-xs',
                ]"
                :aria-current="tab.current ? 'page' : undefined"
              >
                {{ tab.name }}
              </button>
            </nav>
          </div>
        </div>
      </div>
    </template>

    <div class="max-w-6xl mx-auto">
      <div class="mx-auto sm:mx-6 lg:mx-8">
        <div v-if="tabs[0].current" class="py-8 px-2">
          <div v-if="$page.props.jetstream.canUpdateProfileInformation">
            <update-profile-information-form :user="$page.props.user" />
          </div>

          <div>
            <affiliation class="mt-10" />
          </div>
        </div>

        <div v-if="tabs[1].current" class="py-8 px-2">
          <div v-if="$page.props.jetstream.canUpdatePassword">
            <update-password-form />
          </div>

          <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication" class="mt-10">
            <two-factor-authentication-form class="mt-10 sm:mt-0" />
          </div>

          <div class="mt-10">
            <logout-other-browser-sessions-form
              :sessions="$page.props.sessions"
              class="mt-10 sm:mt-0"
            />
          </div>

          <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
            <div class="mt-10">
              <delete-user-form class="mt-10 sm:mt-0" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </clinician-app-layout>
</template>

<script>
import DeleteUserForm from './DeleteUserForm.vue';
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm.vue';
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm.vue';
import UpdatePasswordForm from './UpdatePasswordForm.vue';
import UpdateProfileInformationForm from './UpdateProfileInformationForm.vue';
import ClinicianAppLayout from '@/Layouts/ClinicianAppLayout.vue';
import Affiliation from '@/Pages/Clinician/Profile/Affiliation.vue';

export default {
  props: ['sessions'],

  components: {
    Affiliation,
    ClinicianAppLayout,
    DeleteUserForm,
    LogoutOtherBrowserSessionsForm,
    TwoFactorAuthenticationForm,
    UpdatePasswordForm,
    UpdateProfileInformationForm,
  },
  data() {
    return {
      tabs: [
        {
          id: 'information',
          name: 'Information',
          current: true,
        },
        {
          id: 'security',
          name: 'Security',
          current: false,
        },
      ],
    };
  },
  methods: {
    setTabState(id) {
      this.tabs.forEach((tab) => {
        tab.current = tab.id === id;
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>
